import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { inject } from '@angular/core';
import { LocalStorageService } from '../services/storage/local-storage.service';

export const onboardingPageGuard: CanActivateFn = route => {
  const storageService = inject(LocalStorageService);
  const router = inject(Router);
  const skipOnboardingPage = storageService.getItem('skipOnboardingPage');
  if (skipOnboardingPage) {
    return true;
  } else {
    const onboardingTree = router.createUrlTree(['onboarding'], {
      queryParams: route.queryParams,
    });
    return new RedirectCommand(onboardingTree);
  }
};
